import React from 'react'
import SbcCommon from './SbcCommon';
import SbcWrapper from './SbcWrapper';
import SbcOptions from './SbcOptions';

// sidebar panel for checkbox
export default function SbcCheckbox({
    data,
    handleIptChange,
    handleOptions,
    handleSwitchChange,
    handleSelectChange,
    handleMultiIptChange
}) {

    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
            <SbcOptions
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
                handleOptions={handleOptions}
            />
        </SbcWrapper>
    )
}
